import React from 'react';
import { connect } from 'react-redux';

import geofences from 'APP_ROOT/data/geofences';

class GeofenceBadge extends React.PureComponent {

    renderPolygonBadge() {
        return (
            <div className='polygon-badge mr-1' style={{
                '--geofence-bgcolor': this.props.color,
                display: 'inline-block',
                verticalAlign: 'top',
                width: '16px',
                height:'16px',
            }}>
                <div></div>
            </div>
            
        )
    }

    renderCircleBadge() {
        return (
            <span className="rounded-circle mr-1" style={{
                display: 'inline-block',
                verticalAlign: 'top',
                width: '16px',
                height:'16px',
                background: this.props.color
            }}></span>
        )
    }
    render() {
        return (
            <div className="geofence-badge">
                {this.props.type === 'Polygon' ? this.renderPolygonBadge() : this.renderCircleBadge()}                
                {this.props.name}
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        name: geofences.Selectors.geofenceName(state, ownProps.geofenceId),
        color: geofences.Selectors.geofenceColor(state, ownProps.geofenceId),
        type: geofences.Selectors.geofenceType(state, ownProps.geofenceId)
    };
};

export default connect(mapStateToProps)(GeofenceBadge);
